export class PlanoRefeicaoAlimento {
  idRefeicaoAlimento!: number;
  idTaco!: number;
  nomeOriginal?: String;
  quantidadeGramas!: number;
  gramas?: number;
  
  nomePersonalizado?: string;
  kcaloriasPersonalizado?: number;
  proteinasPersonalizado?: number;
  carboidratosPersonalizado?: number;
  lipidiosPersonalizado?: number;
}
